import React, { useEffect, useRef } from "react";
import Modal from "react-modal";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import history from "web/script/utils/history";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./product-gallery-modal.css";

interface ProductGalleryModalProps {
    children: React.ReactNode;
    onClose: () => void;
    onOpen: () => void;
    isOpen: boolean;
}

//  A different component is used for browser windows bigger then 576
const thisGalleryHiddenBreakpoint = 576;

function ProductGalleryModal({
    children,
    onClose,
    onOpen,
    isOpen = false,
}: ProductGalleryModalProps): React.ReactElement {
    const appElement = useRef<HTMLDivElement>(null);

    function handleClose(): void {
        onClose();
        clearAllBodyScrollLocks();
        // since we are pushing a state onOpen we need to force
        // history back if the user don't click the back button
        history.back();
    }

    function onResize(): void {
        if (window.innerWidth >= thisGalleryHiddenBreakpoint && isOpen) {
            handleClose();
        }
    }

    function onBack(): void {
        onClose();
        clearAllBodyScrollLocks();
    }

    function handleOpen(): void {
        if (onOpen) {
            onOpen();
        }
        // ?
        history.updateQuery("open", "1", false);
        disableBodyScroll(appElement.current);
    }

    useEffect(() => {
        if (appElement.current) {
            Modal.setAppElement(appElement.current);
        }

        window.addEventListener("popstate", onBack);
        window.addEventListener("resize", onResize);
        return (): void => {
            window.removeEventListener("popstate", onBack);
            window.removeEventListener("resize", onResize);
        };
    });

    return (
        <div ref={appElement}>
            <Modal
                overlayClassName={styles.overlay}
                className={styles.modal}
                appElement={document.body}
                onAfterOpen={handleOpen}
                onRequestClose={handleClose}
                isOpen={isOpen}
            >
                <div className={styles.close}>
                    <CloseButton onClick={handleClose} />
                </div>
                {children}
            </Modal>
        </div>
    );
}

export default ProductGalleryModal;
